import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
    DiJavascript1,
    DiReact,
    DiNodejs,
    DiMongodb,
    DiPython,
    DiGit,
    DiJava, DiAws, DiMysql,
} from "react-icons/di";
import {
    SiRedis,
    SiFirebase,
    SiNextdotjs,
    SiSolidity,
    SiPostgresql,
    SiTypescript,
    SiSpringboot,
    SiOracle,
    SiAngularuniversal,
    SiAngular,
    SiTerraform,
    SiLinux,
    SiApachetomcat, SiTailwindcss, SiAnaconda, SiApache, SiRedhat, SiApachemaven,
} from "react-icons/si";
import {TbBrandGolang, TbBrandReactNative, TbBrandSwift} from "react-icons/tb";
import {SiSwift, SiCloudflare, SiOpenai} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
          <DiJava />
      </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiApachemaven/>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
            <SiSpringboot />
        </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiAngular/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiTailwindcss />
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <DiNodejs />
        </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiOracle />
      </Col>
        <Col xs={4} md={2} className="tech-icons">
            <DiMysql />
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <DiPython />
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiAnaconda />
        </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiRedhat />
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiLinux />
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiApachetomcat />
        </Col>

        <Col xs={4} md={2} className="tech-icons">
            <SiApache />
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiTerraform/>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
            <DiAws/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiSwift/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <TbBrandReactNative/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiCloudflare/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiOpenai/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <DiMongodb/>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
            <SiPostgresql/>
        </Col>
    </Row>
  );
}

export default Techstack;
